// Environment variable validation utility
export const validateEnvVars = () => {
  const requiredEnvVars = [
    'NEXT_PUBLIC_API_URL',
    'NEXT_PUBLIC_BASE_URL',
    'NEXT_PUBLIC_MAIL_URL',
    'AUTHORIZE_NET_API_LOGIN_ID',
    'AUTHORIZE_NET_TRANSACTION_KEY',
    'FILEMAKER_USERNAME',
    'FILEMAKER_PASSWORD'
  ];

  const missingVars: string[] = [];

  requiredEnvVars.forEach(varName => {
    if (!process.env[varName]) {
      missingVars.push(varName);
    }
  });

  if (missingVars.length > 0) {
    console.error('Missing required environment variables:', missingVars);
    throw new Error(`Missing required environment variables: ${missingVars.join(', ')}`);
  }
};

export const getEnvVar = (varName: string, defaultValue?: string): string => {
  const value = process.env[varName];
  if (!value && !defaultValue) {
    throw new Error(`Environment variable ${varName} is required but not set`);
  }
  return value || defaultValue || '';
};

// FileMaker specific environment variables
export const getFileMakerCredentials = () => {
  // Use the working credentials directly
  const username = "webadmin";
  const password = "Robust@321";
  return { username, password };
};
